import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import StatsInfoElement from "../StatsInfoElement/StatsInfoElement";

import { gymStatsInfo, athleteStatsInfo } from "./StatsDefaultInformation";

import { isObjectEmpty } from "../../assets/Js/isObjectEmpty";
import { Tab } from "./Tab";
import { Spinner } from "../Spinner/Spinner";
import { roleEnum } from "../../assets/Js/roleEnum";

export default function StatsInfoBar({
  statsInfo,
  isLoading,
  desiredRole,
  loggedInUserRole,
}) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (statsInfo && !isObjectEmpty(statsInfo)) {
      setStats(prepareData(statsInfo));
    }
  }, [statsInfo]);

  const prepareData = (data) => {
    let { Engagements, Overviews } = data;
    let _statsInfo =
      desiredRole === roleEnum.owner ? gymStatsInfo : athleteStatsInfo;

    let _engagements = Object.entries(Engagements || {});
    let _overviews = Object.entries(Overviews || {});

    _engagements?.map((currVal) => {
      let foundVal = _statsInfo.Engagements.find(
        (eachVal) => eachVal.name === currVal[0]
      );

      if (foundVal) {
        foundVal.value = currVal[1];
      }
    });

    _overviews?.map((currVal) => {
      let foundVal = _statsInfo.Overviews.find(
        (eachVal) => eachVal.name === currVal[0]
      );

      if (foundVal) {
        foundVal.value = currVal[1];
      }
    });

    return Object.entries(_statsInfo);
  };

  return (
    <>
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card mb-4">
          <div class="card">
            {isLoading ? (
              <div className="mt-5 mb-5">
                <Spinner />
              </div>
            ) : (
              <div class="card-body dashboard-tabs p-0">
                <ul class="nav nav-tabs px-4" role="tablist">
                  {stats?.map((eachTab, index) => (
                    <Tab
                      key={index}
                      id={eachTab[0]}
                      title={eachTab[0]}
                      defaultSelection={!index}
                    />
                  ))}
                </ul>
                <div class="tab-content py-0 px-0">
                  {stats?.map((eachSection, index) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${!index && "active show"}`}
                      id={eachSection[0]}
                      role="tabpanel"
                      aria-labelledby={`${eachSection[0]}-tab`}
                    >
                      <div className="d-flex flex-wrap justify-content-xl-between">
                        {eachSection[1]?.map((eachItem, index) => (
                          <StatsInfoElement
                            key={index}
                            iconClasses={eachItem.iconClasses}
                            IconImage={eachItem.iconImage}
                            textClasses="text-muted"
                            title={eachItem?.title}
                            subTitle={eachItem?.value}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

StatsInfoBar.propTypes = {
  statsInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  desiredRole: PropTypes.string,
  loggedInUserRole: PropTypes.string,
};
